<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	     -->
			<!-- School  -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">School</label>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false || UserLevelID != 1"
						value="1"
						label="All Schools"
						[(ngModel)]="SelectedGroupValue"
					></p-radioButton>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false"
						value="2"
						label="Current School Only"
						[(ngModel)]="SelectedGroupValue"
					></p-radioButton>
				</div>
			</div>

			<!-- 	     -->
			<!-- CODE    -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Code</label>
				</div>

				<div style="margin-left: 10px">
					<input
						type="text"
						pInputText
						[(ngModel)]="rInfractionCD"
						maxlength="50"
						style="width: 350px"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 50 characters</label>
				</div>
			</div>
			<!-- 	     	 -->
			<!-- Description -->
			<!-- 	     	 -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Description</label>
				</div>

				<div style="margin-left: 10px">
					<input
						type="text"
						pInputText
						[(ngModel)]="rInfractionDesc"
						maxlength="100"
						style="width: 350px"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!--  	   	                   -->
			<!-- Infraction Group Selector -->
			<!-- 		             	   -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Infraction Group</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedInfractionGroupSelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true"
						[(ngModel)]="SelectedInfractionGroup"
						(ngModelChange)="onInfractionGroupChange($event)"
					>
						<option *ngFor="let r of lstInfractionGroupItems" [ngValue]="r">
							{{ r.InfractionGroupDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	                   -->
			<!-- Infraction Level Selector -->
			<!-- 		             	   -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Level</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedInfractionLevelSelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
						[(ngModel)]="SelectedInfractionLevel"
						(ngModelChange)="onInfractionLevelChange($event)"
					>
						<option *ngFor="let r of lstInfractionLevelItems" [ngValue]="r">
							{{ r.InfractionLevelDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	         				-->
			<!-- Is Weapon Type / Is Classroom -->
			<!-- 		        				-->
			<div class="column-item">
				<div>
					<label style="margin-left: 85px">Add weapon type</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsWeaponType" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Can be added from Classroom</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsEDCRAssignable" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>
			</div>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 		  -->
<!-- ASSIGNED ACTIONS -->
<!-- 		 		  -->
<div class="main-action-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onRemove()" [disabled]="isViewOnly == true">Remove</button>
			<img class="info-img" (click)="onToggleInfo1()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Assigned Actions</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo1 == true ? 'block' : 'none'">
			<label>&#9900; Total Assigned Actions: {{ lstInfractionPenaltyItems.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 					  -->
		<!-- Display Assigned     -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstInfractionPenaltyItems"
				[paginator]="true"
				[(rows)]="pagerows1"
				[(first)]="pagefirst1"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedInfractionPenalty"
				dataKey="PenaltyID"
				(onSort)="onHandleSort1($event)"
				(onRowSelect)="onRowSelect1($event)"
				(onRowUnselect)="onRowUnselect1($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="isPrimary" class="fixwidth-08">Default<p-sortIcon field="isPrimary"></p-sortIcon></th>
						<th pSortableColumn="PenaltyCD">Code<p-sortIcon field="PenaltyCD"></p-sortIcon></th>
						<th pSortableColumn="PenaltyDesc">Description<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
						<th pSortableColumn="Message">Alert Message<p-sortIcon field="Message"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rPenaltyItem>
					<tr [pSelectableRow]="rPenaltyItem">
						<td class="fixwidth-08">
							<div>
								<p-checkbox
									[(ngModel)]="rPenaltyItem.isPrimary"
									[binary]="true"
									(onChange)="onChangePrimary(rPenaltyItem)"
									[disabled]="isViewOnly == true"
								></p-checkbox>
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyCD }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc" style="font-weight: bold" [ngStyle]="{ color: rPenaltyItem.FontColor }">
								{{ rPenaltyItem.Message }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.SchoolID <= 0,
									'table-color-def-4': rPenaltyItem.SchoolID > 0
								}"
							>
								{{ rPenaltyItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.DefinedByID == 1,
									'table-color-def-2': rPenaltyItem.DefinedByID == 2,
									'table-color-def-3': rPenaltyItem.DefinedByID == 3,
									'table-color-def-4': rPenaltyItem.DefinedByID == 4
								}"
							>
								{{ rPenaltyItem.DefinedByDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstInfractionPenaltyItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No actions assigned...</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- ACTIONS -->
<!-- 		 -->
<div class="main-action-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onAssign()" [disabled]="isViewOnly == true">Assign</button>
			<img class="info-img" (click)="onToggleInfo2()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Actions</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo2 == true ? 'block' : 'none'">
			<label>&#9900; Total Actions: {{ lstPenaltyItems.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 				 -->
		<!-- Display Actions -->
		<!-- 				 -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtActions
				[value]="lstPenaltyItems"
				[paginator]="true"
				[(rows)]="pagerows2"
				[(first)]="pagefirst2"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedPenalty"
				dataKey="PenaltyID"
				(onSort)="onHandleSort2($event)"
				(onRowSelect)="onRowSelect2($event)"
				(onRowUnselect)="onRowUnselect2($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 				-->
					<!-- Filter Section -->
					<!-- 				-->
					<tr>
						<th>
							<p-columnFilter type="text" field="PenaltyCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="PenaltyDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="SchoolsDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterSchoolsDesc
										[ngModel]="value"
										[options]="lstSchoolsDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterDefinedByDesc
										[ngModel]="value"
										[options]="lstDefinedByDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
					</tr>

					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="PenaltyCD">Code<p-sortIcon field="PenaltyCD"></p-sortIcon></th>
						<th pSortableColumn="PenaltyDesc">Description<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
						<th pSortableColumn="Message">Alert Message<p-sortIcon field="Message"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rPenaltyItem>
					<tr [pSelectableRow]="rPenaltyItem">
						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyCD }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc" style="font-weight: bold" [ngStyle]="{ color: rPenaltyItem.FontColor }">
								{{ rPenaltyItem.Message }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.SchoolID <= 0,
									'table-color-def-4': rPenaltyItem.SchoolID > 0
								}"
							>
								{{ rPenaltyItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.DefinedByID == 1,
									'table-color-def-2': rPenaltyItem.DefinedByID == 2,
									'table-color-def-3': rPenaltyItem.DefinedByID == 3,
									'table-color-def-4': rPenaltyItem.DefinedByID == 4
								}"
							>
								{{ rPenaltyItem.DefinedByDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstPenaltyItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No actions configured...</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onAddUpdate()" [disabled]="isBusy == true || isViewOnly == true">Save</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
